<template>
	<div id="app" style="opacity: 0;transition: opacity 3s">
		<div style="height:2vh"></div>
		<div class="main-display-width" style="position:relative; left:0px;z-index: 200;margin-bottom: 2vh;">

			<Logo-primary style="margin:auto;cursor: pointer" v-on:click="goHome"/>
			<div class="flex-center" style="width:25px;height:100%;top:0px;right:6px;position: absolute;">
				<icon-menu style="width:25px; cursor:pointer"
				           @click.native="showMenu"/>
			</div>

		</div>


		<main-menu ref="menu" style="position:fixed;left:0px;top:0px;z-index: 300"></main-menu>

		<transition name="fade">
			<router-view style="position:absolute;left:0px;width:100%;z-index: 100"></router-view>
		</transition>
		<div class="flex-center" ref="loading"
			 style="left:0px;top:0px;position:absolute;width:100%;height:100%;z-index: 50;opacity:.5">
			<svg width="50px" height="50px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"
				 preserveAspectRatio="xMidYMid" class="lds-dual-ring" style="background: none;">
				<circle cx="50" cy="50" fill="none" stroke-linecap="round" r="40" stroke-width="10" stroke="#dddddd"
						stroke-dasharray="62.83185307179586 62.83185307179586" transform="rotate(59.9688 50 50)">
					<animateTransform attributeName="transform" type="rotate" calcMode="linear"
									  values="0 50 50;360 50 50" keyTimes="0;1" dur="3.3s" begin="0s"
									  repeatCount="indefinite"></animateTransform>
				</circle>
			</svg>
		</div>



	</div>
</template>

<script>
	import Vue from 'vue';
	import LogoPrimary from './components/LogoPrimary';
	import IconMenu from "./components/IconMenu";
	import MainMenu from "./components/MainMenu";
	import VueRouter from 'vue-router';
	import VueMq from 'vue-mq'

	Vue.use(VueMq, {
		breakpoints: { // default breakpoints - customize this
			sm: 760,
			md: 1920,
			lg: Infinity,
		}
	});

	import Home from "./components/Home";
	import Team from "./components/Team";
	import Projects from "@/components/Projects";
	import ReadMore from "@/components/ReadMore";
	import Contact from "@/components/Contact";

	Vue.use(VueRouter);

	Vue.mixin({
		methods: {
			capitalizeFirstLetter: str => str.charAt(0).toUpperCase() + str.slice(1)
		}
	});

	// const baseURL = "http://localhost:5000/default/";
	const baseURL = "https://d.hive.properties/default/";

	const routes = [
		{path: '/', component: Home, props:{baseURL: baseURL}},
		{path: '/team', component: Team, props:{baseURL: baseURL}},
		{path: '/contact', component: Contact, props:{baseURL: baseURL}},
		{path: '/collections', component: Projects, props:{baseURL: baseURL}},
		{path:'/collections/:id',component:ReadMore, props:{sub:'projects',baseURL: baseURL}}
	];
	const router = new VueRouter({
		routes, // short for `routes: routes`
		mode: 'history'
	});

	export default {
		router,
		name: 'app',
		data() {
			return {
				sliderConf: null
			}
		},
		methods: {
			showMenu() {
				// console.log(this.$refs.menu);
				this.$refs.menu.show();
			},
			goHome(){
				router.push("/");
				console.log("go home");
			}
		},
		components: {
			MainMenu,
			LogoPrimary,
			IconMenu
		},
		mounted() {
			setTimeout(() => {
				this.$el.style.opacity = '1';
			}, 10);
		}
	}

</script>

<style>
	#app {
		font-family: "Proxima Nova", sans-serif;
		font-weight: lighter;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color:#666666;
	}

	.flex-center {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.fill-gold rect, .fill-gold line, .fill-gold polygon, .fill-gold path {
		fill: #B79939;
	}
	.font-gold{
		color: #B79939;
	}
	.font-slogan{
		color: #B79939;
		font-family: Notera;
		font-size:2.3em;
		text-transform: capitalize;
	}
	.font-white{
		color:#bbbbbb;
	}
	.font-grey{
		color:#888888;
	}
	.font-name{
		font-size: 14px;font-weight: bold;letter-spacing: .2em;
	}
	.font-title{
		font-size: 12px;font-weight:bold;letter-spacing: .2em;
	}
	.font-subtitle{
		font-size: 12px;letter-spacing: .2em;
	}
	.font-content{
		letter-spacing: .1em;font-size: 13px;text-align: left
	}
	.bg-gold{
		background-color: #B79939;
	}

	.fill-white rect, .fill-white line, .fill-white polygon, .fill-white path {
		fill: #eeeeee;
	}
	.bg-white{
		background-color: #eeeeee;
	}
	.bg-dark{
		background-color: #aaaaaa;
	}
	.bg-darker{
		background-color: #666666;
		color:#cccccc;
	}
	.full-size {
		width: 100%;
		height: 100%;
	}

	.bg-cover {
		background-size: cover;
		background-position: center;
	}

	.origin {
		position: absolute;
		left: 0px;
		top: 0px;
	}

	.uppercase {
		text-transform: uppercase;
	}
	.content-font{
		letter-spacing: .1em;font-size: 13px;text-align: left
	}
	.text-justify{
		text-align: justify;
		text-justify: inter-word;
	}
	.text-center{
		text-align: center;
	}
	.border-box{
		box-sizing: border-box
	}
	.main-display-width{
		width:100%;
		max-width: 1218px;margin:auto
	}
	.border-red{
		border:1px solid red;
	}

	.fade-enter-active {
		transition: opacity 3s ease-in-out;
	}

	.fade-enter-to {
		opacity: 1;
	}

	.fade-enter {
		opacity: 0;
	}
</style>
